import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '@/App';
import { Smartphone, X } from 'lucide-react';

const InstallPWABanner = () => {
  const { language } = useContext(AuthContext);
  const [show, setShow] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);

  const t = (es, ca) => language === 'ca' ? ca : es;

  useEffect(() => {
    // Only show on mobile and if not already installed as PWA
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
      || window.navigator.standalone === true;
    const dismissCount = parseInt(localStorage.getItem('pwa_banner_seen') || '0');

    if (isMobile && !isStandalone && dismissCount < 3) {
      // Small delay so it doesn't appear instantly
      const timer = setTimeout(() => setShow(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const dismiss = () => {
    const count = parseInt(localStorage.getItem('pwa_banner_seen') || '0');
    localStorage.setItem('pwa_banner_seen', String(count + 1));
    setShow(false);
  };

  if (!show) return null;

  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  return (
    <div data-testid="pwa-install-banner" className="mx-4 mb-4 rounded-2xl bg-gradient-to-r from-violet-500/15 to-teal-500/10 border border-violet-400/20 p-4 fade-in">
      {!showInstructions ? (
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-violet-500/20 flex items-center justify-center">
            <Smartphone className="w-5 h-5 text-violet-300" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm text-gray-200 leading-relaxed">
              {t(
                'Añade ESSENC·IA a tu pantalla de inicio para recibir recordatorios diarios y acceder con un solo clic.',
                'Afegeix ESSENC·IA a la teva pantalla d\'inici per rebre recordatoris diaris i accedir-hi amb un sol clic.'
              )}
            </p>
            <div className="flex items-center gap-4 mt-3">
              <button
                data-testid="pwa-how-to-btn"
                onClick={() => setShowInstructions(true)}
                className="text-sm font-semibold text-violet-300 hover:text-violet-200 transition-colors"
              >
                {t('Cómo hacerlo', 'Com fer-ho')}
              </button>
              <button
                data-testid="pwa-dismiss-btn"
                onClick={dismiss}
                className="text-sm text-gray-500 hover:text-gray-400 transition-colors"
              >
                {t('Ahora no', 'Ara no')}
              </button>
            </div>
          </div>
          <button onClick={dismiss} className="flex-shrink-0 text-gray-600 hover:text-gray-400 transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <h4 className="text-sm font-semibold text-violet-300">
              {t('Instalar ESSENC·IA', 'Instal·lar ESSENC·IA')}
            </h4>
            <button onClick={dismiss} className="text-gray-600 hover:text-gray-400 transition-colors">
              <X className="w-4 h-4" />
            </button>
          </div>
          {isIOS ? (
            <div className="space-y-2">
              <p className="text-sm text-gray-300">
                <span className="font-semibold text-teal-300">1.</span>{' '}
                {t(
                  'Toca el botón de compartir (el cuadrado con la flecha hacia arriba)',
                  'Toca el botó de compartir (el quadrat amb la fletxa cap amunt)'
                )}
              </p>
              <p className="text-sm text-gray-300">
                <span className="font-semibold text-teal-300">2.</span>{' '}
                {t(
                  'Selecciona "Añadir a pantalla de inicio"',
                  'Selecciona "Afegir a la pantalla d\'inici"'
                )}
              </p>
            </div>
          ) : (
            <div className="space-y-2">
              <p className="text-sm text-gray-300">
                <span className="font-semibold text-teal-300">1.</span>{' '}
                {t(
                  'Toca el menú (los tres puntos arriba a la derecha)',
                  'Toca el menú (els tres punts a dalt a la dreta)'
                )}
              </p>
              <p className="text-sm text-gray-300">
                <span className="font-semibold text-teal-300">2.</span>{' '}
                {t(
                  'Selecciona "Instalar aplicación" o "Añadir a pantalla de inicio"',
                  'Selecciona "Instal·lar aplicació" o "Afegir a la pantalla d\'inici"'
                )}
              </p>
            </div>
          )}
          <button
            onClick={dismiss}
            className="w-full mt-2 py-2 text-sm text-center text-gray-500 hover:text-gray-400 transition-colors"
          >
            {t('Entendido', 'Entès')}
          </button>
        </div>
      )}
    </div>
  );
};

export default InstallPWABanner;
